import { ProductType } from "../../../../store/slice/productsSlice";
import { UserAddress, UserOrder } from "../../../../store/slice/userSlice";
import "./OrderCard.scss";
import React from "react";

export type OrderStatus =
  | "Commandé"
  | "Expédié"
  | "En cours de livraison"
  | "Livré";

export type Order = {
  id: string;
  address: UserAddress;
  status: OrderStatus;
  deliveryDate?: string;
  progress: number;
  products: {
    Code: string;
    quantity: number;
    product: ProductType;
  }[];
  shippingId: string;
  billingId: string;
};

type PropsOrderCard = {
  order: UserOrder;
  onViewOrder: (id: string) => void;
  onReportProblem: (id: string) => void;
};

// const getProgressFromStatus = (status: OrderStatus): number => {
//   switch (status) {
//     case "Commandé":
//       return 25;
//     case "Expédié":
//       return 50;
//     case "En cours de livraison":
//       return 75;
//     case "Livré":
//       return 100;
//     default:
//       return 0;
//   }
// };

const OrderCard: React.FC<PropsOrderCard> = ({
  order,
  onViewOrder,
  onReportProblem,
}) => {
  const products = order.items.slice(0, 5);
  const remainingCount = order.items.length - products.length;
  // const progress = getProgressFromStatus(order.status);

  return (
    <div className="order-card">
      {/* <p>
        Livrée à :
        <strong>
          “{order.addressLine1} {order.address.city} 
          {order.address.country}”
        </strong>
      </p> */}
      <p>
        Statut de la commande : Payé
        {/* {order.status === "Livré" ? (
          <span className="delivered">LIVRÉE LE {order.deliveryDate}</span>
        ) : (
          <span className="in-progress">{order.status.toUpperCase()}</span>
        )} */}
      </p>

      {/* <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${progress}%` }} />
        <div className="progress-base" />
      </div> */}

      <div className="order-content">
        {products.map((pdt, index) =>
          pdt.imageUrl ? (
            <img key={index} src={pdt.imageUrl} alt={`Produit ${index + 1}`} />
          ) : (
            <div className="more-images">{pdt.designation.slice(0, 20)}</div>
          )
        )}
        {remainingCount > 0 && (
          <div className="more-images">+{remainingCount}</div>
        )}
      </div>

      <div className="actions">
        <button className="view" onClick={() => onViewOrder(order.id)}>
          Voir la commande
        </button>
        <button className="report" onClick={() => onReportProblem(order.id)}>
          Signaler un problème
        </button>
      </div>
    </div>
  );
};

export default OrderCard;
